import React from "react";
import { useSelector } from "react-redux";

import boxContainer from "../box-container";

import { Images } from "../../config";

const ApplicationTopAnalytics = () => {
  const {
    acceptedApplicationsCount,
    rejectedApplicationsCount,
    waitlistedApplicationsCount,
    pendingApplicationsCount,
  } = useSelector((state) => state.application);

  const appData = [
    {
      title: "Pending Applications",
      icon: Images.PendingApplications,
      value: pendingApplicationsCount,
    },
    {
      title: "Accepted Applications",
      icon: Images.AcceptedApplications,
      value: acceptedApplicationsCount,
    },
    {
      title: "Waitlisted Applications",
      icon: Images.WaitlistedApplications,
      value: waitlistedApplicationsCount,
    },
    {
      title: "Rejected Applications",
      icon: Images.RejectedApplications,
      value: rejectedApplicationsCount,
    },
  ];

  return (
    <div className="grid grid-cols-4 gap-5">
      {appData?.map((item, index) => (
        <boxContainer.LiteBoxContainer bg="bg-[#fcfffe]" key={index}>
          <div className="flex flex-col gap-2 p-4">
            <div className="text-[1.25em] font-semibold">{item?.title}</div>
            <div className="flex justify-between items-center">
              <div className="text-[2.813em] font-bold ">{item?.value}</div>
              <img src={item?.icon} className="h-[3.375em]" />
            </div>
          </div>
        </boxContainer.LiteBoxContainer>
      ))}
    </div>
  );
};

export default ApplicationTopAnalytics;
